
import axios from 'axios'

import {  Loading } from 'element-ui';
//创建axios实例
const instance = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: 20000,   // 请求超时时间
})
 // loading函数
// 记录请求次数
/* let needLoadingRequestCount = 0;
let loading;
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.9)',
  });
}
function endLoading() {
  // 延迟500ms，防止网速特快加载中画面一闪而过
  setTimeout(function () {
    if (loading) loading.close();
  }, 500);
}
// 打开loading
function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}
// 关闭loading
function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
} */
//请求拦截器
instance.interceptors.request.use( 
  (config) => {
    // 打开loading
    // showFullScreenLoading();
    return config;
  },
  (error) => {
    // 关闭loading
    // tryHideFullScreenLoading();
    Promise.reject(error);
  },
)
 
//响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 将loading移除
    setTimeout(() => {
     // 关闭loading
      // tryHideFullScreenLoading();

    }, 200);
    return response
  },
  (error) => {

    // 将loading移除
    setTimeout(() => {
      // tryHideFullScreenLoading();
    }, 200);
    return Promise.reject(error.response);
  }
);
 
//post请求
const post = function (url, params) {
  return new Promise((resolve, reject) => {
    instance.post(url, params)
            .then(res=> {
                 resolve(res.data);
            }).catch(error => {reject(error);})
    });
}
 
//暴露post、get方法
export default {post}



// WEBPACK FOOTER //
// ./src/api/index.js